import API from '@services/API';
import { setError, startSpinner, stopSpinner } from '../../common/actionCreators';
import { APPLICATIONS_ACTION_TYPES } from '@constants/actionTypes/applicationsActionType';
import { configs } from '@constants/configs/configs';

export const setApplications = applications => ({
    type: APPLICATIONS_ACTION_TYPES.SET_APPLICATIONS,
    applications
});

/************************

 # Async action creators

 ************************/

const actions = { setError, startSpinner, stopSpinner };

export const getApplications = (coverageYear) => async (dispatch, getState) => {
    const URL = configs.endpoints.APPLICATIONS_NEW.processReplacements({ coverageYear });
    const data = await API.getData(URL, dispatch, actions, true, getState());
    if (data) {
        dispatch(setApplications(data));
        return data;
    } else {
        console.error('Cannot getApplications', URL);
    }
};